import { render, staticRenderFns } from "./NewsSlider.vue?vue&type=template&id=7edbe3f6&"
import script from "./NewsSlider.vue?vue&type=script&lang=js&"
export * from "./NewsSlider.vue?vue&type=script&lang=js&"
import style0 from "./NewsSlider.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7edbe3f6')) {
      api.createRecord('7edbe3f6', component.options)
    } else {
      api.reload('7edbe3f6', component.options)
    }
    module.hot.accept("./NewsSlider.vue?vue&type=template&id=7edbe3f6&", function () {
      api.rerender('7edbe3f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/parts/itemSets/NewsSlider.vue"
export default component.exports